import React from "react";
import { useApp } from "@/state/AppContext";
import { localized } from "@/theme/tenantTheme";
import { shortDate } from "@/lib/format";
import { OfferBadge } from "@/components/OfferBadge";

/** The business's own offers, moved verbatim from `BusinessMiniSite`'s aside. Distinct from
 * `RailAd`: this is the shop's data, not a platform-sold placement. */
export function OffersCard({ offers }) {
  const { t, lang } = useApp();
  if (offers.length === 0) return null;
  return (
    <div
      className="space-y-3 rounded-2xl border border-[hsl(var(--accent))]/40 bg-[hsl(var(--accent))]/10 p-6"
      data-testid="business-offers"
    >
      <h3 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
        {t("offers.onThisShop")}
      </h3>
      {offers.map((offer) => (
        <div key={offer.id} className="space-y-1" data-testid={`business-offer-${offer.id}`}>
          <OfferBadge offer={offer} />
          <p className="font-heading text-base font-semibold">{localized(lang, offer, "title")}</p>
          <p className="text-sm text-muted-foreground">{localized(lang, offer, "description")}</p>
          <p className="tabular-nums text-xs text-muted-foreground">
            {t("offers.endsOn", { date: shortDate(offer.ends_on, lang) })}
          </p>
        </div>
      ))}
    </div>
  );
}
